module.exports = __webpack_public_path__ + "img/1977.2419d1a2.png";